import React from 'react';
import {Config_common} from '../../common/core/entry-point/Config_common';

export const AppContext = React.createContext<Config_common>(new Config_common());
